/**
 * 全站 IndexedDB Client（主线程）
 *
 * 作用：
 * - 启动 Web Worker（assets/worker.js）
 * - 提供 Promise 风格的 KV 读写 API
 * - 暴露全局对象：window.POD_IDB / window.POD_IMAGE_STORE
 *
 * 适用：
 * - 你希望“全站都能读 latest / 历史记录”的场景
 *
 * 依赖：
 * - assets/worker.js（Worker 端 IndexedDB 实现）
 */

(function () {
  if (window.POD_IDB && window.POD_IMAGE_STORE) return; // 已初始化过就复用

  function getWorkerAssetUrl() {
    // Shopify 主题 assets 的 URL 通常是 /cdn/.../assets/<file>.js?v=xxx
    // 这里优先从当前脚本（idb-client.js）的 src 推导出同目录的 worker.js
    const scripts = document.getElementsByTagName('script');
    let selfSrc = '';
    for (let i = scripts.length - 1; i >= 0; i--) {
      const src = scripts[i].getAttribute('src') || '';
      if (src.includes('idb-client.js')) {
        selfSrc = src;
        break;
      }
    }
    if (!selfSrc) {
      // 兜底：部分主题会把 assets 暴露在 /assets/ 下（不保证）
      return '/assets/worker.js';
    }
    const u = new URL(selfSrc, window.location.origin);
    u.pathname = u.pathname.replace(/idb-client\.js(\.map)?$/, 'worker.js');
    // 注意：worker.js 通常也带版本参数更安全，这里不强制去掉 search
    // 因为 Shopify CDN 的版本参数是用于缓存控制的。
    u.hash = '';
    return u.toString();
  }

  function createIdbWorkerClient() {
    const workerUrl = getWorkerAssetUrl();
    const worker = new Worker(workerUrl);
    let seq = 0;
    const pending = new Map();

    worker.onmessage = (e) => {
      const msg = e.data || {};
      const { requestId } = msg;
      if (!pending.has(requestId)) return;
      const { resolve, reject } = pending.get(requestId);
      pending.delete(requestId);
      if (msg.ok) resolve(msg);
      else reject(new Error(msg.error || 'Worker error'));
    };

    function call(type, payload) {
      const requestId = `${Date.now()}-${++seq}`;
      return new Promise((resolve, reject) => {
        pending.set(requestId, { resolve, reject });
        worker.postMessage({ requestId, type, ...payload });
      });
    }

    return {
      put: (key, value) => call('put', { key, value }),
      get: (key) => call('get', { key }),
      del: (key) => call('delete', { key }),
      keys: () => call('keys', {})
    };
  }

  // 全局单例：全站复用同一个 worker client
  window.POD_IDB = window.POD_IDB || createIdbWorkerClient();

  // 读取方法（供其它页面调用）
  // 用法示例：
  //   const latest = await window.POD_IMAGE_STORE.getLatest();
  //   if (latest) img.src = latest.dataUrl;
  window.POD_IMAGE_STORE = window.POD_IMAGE_STORE || {
    async getLatest() {
      const res = await window.POD_IDB.get('latest');
      return res.value || null;
    },
    async getByKey(key) {
      const res = await window.POD_IDB.get(key);
      return res.value || null;
    },
    async listKeys() {
      const res = await window.POD_IDB.keys();
      return res.keys || [];
    },
    async remove(key) {
      await window.POD_IDB.del(key);
    }
  };
})();


